import {
  ref, watch, onUnmounted, getCurrentInstance,
} from '@vue/composition-api';
import store from '@/store';
import moment from 'moment';
import toast from '@/utils/toast';
import { getDueDateForInvoice, isEnableBed } from '@/auth/utils';
import invoiceStoreModule from '../invoiceStoreModule';
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default function useInvoiceList() {
  const STORE_MODULE_NAME = 'invoice';
  const { t } = useI18nUtils();
  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, invoiceStoreModule);
  }

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(STORE_MODULE_NAME)) {
      store.unregisterModule(STORE_MODULE_NAME);
    }
  });
  // Use toast
  const toastification = toast();

  const dueDate = getDueDateForInvoice();

  const blankItem = {
    id: 0,
    month: moment(new Date()).format("MM-YYYY"),
    name: '',
    apartment: null,
    room: null,
    bed: null,
    contract: null,
    issueDate: moment(new Date()).toDate(),
    paymentPeriod: null,
    finalDate: null,
    dueDate,
    note: '',
    items: [],
    subTotal: 0,
    discount: 0,
    promotion: 0,
    prepaid: 0,
    tax: 0,
    total: 0,
    typeObject: { title: 'Hóa đơn hàng tháng', id: '1', value: '1' },
    type: '1',
  };



  const item = ref(JSON.parse(JSON.stringify(blankItem)));
  const resetItem = () => {
    item.value = JSON.parse(JSON.stringify(blankItem));
  };
  const paymentItem = ref({});

  const vm = getCurrentInstance().proxy;
  const isHidden = !vm.$can('update', 'invoice') && !vm.$can('delete', 'invoice') && !vm.$can('approve', 'invoice') && !vm.$can('pay', 'invoice');
  // Table Handlers
  const columns = [
    {
      label: 'Mã đơn hàng',
      field: 'id'
    },
    {
      label: 'Thao tác',
      field: 'action',
      tdClass: 'text-center',
      sortable: false,
      width: '100px',
      hidden: isHidden,
    },
    {
      label: 'Xuất hóa đơn VAT',
      field: 'isExportVatInvoice',
    },

    {
      label: t('Khách hàng'),
      field: 'student.name',
      width: '240px',
    },
    {
      label: 'Giá trị đơn hàng trên hóa đơn',
      field: 'total',
      type: 'number',
    },
    {
      label: 'Giá trị đơn hàng trên POS',
      field: 'oldShuttles',
      type: 'number',
    },
    {
      label: 'Có thể xuất hóa đơn tự động',
      field: 'oldStudySessons',
      type: 'number'
    },
    {
      label: 'Giảm giá, lưu ý kiểm tra',
      field: 'numberSessons',
      type: 'number',
      width: '150px',
    },
    {
      label: 'Ngày nhận hàng',
      field: 'dueDate',
    },
  ];
  const selectedDate = ref('')
  const isPOSAccount = ref(true)
  const userData = localStorage.getItem('userData')
  const viettel = ref(false)
  const rows = ref([]);
  const analytics = ref(null);
  // filter
  const paymentPeriod = ref(null)
  const school = ref(null);
  const classObject = ref(null);
  const issueStatus = ref(null)
  const date = ref(null)
  const student = ref(null);
  const status = ref(null);
  const type = ref(null);
  const isEqual = ref(null)
  const isDiscount = ref(null)
  // current selected rows
  const selectedRows = ref([]);
  const isExportable = ref(null)
  const searchTerm = ref('');
  // ssr
  const isLoading = ref(false);
  const totalRecords = ref(0);
  const serverParams = ref({
    searchTerm: '',
    filter: {

    },
    sort: {},
    page: 1,
    perPage: 20,
  });

  //   API Call
  const fetchInvoices = () => {
    isLoading.value = true;
    store
      .dispatch('invoice/fetchInvoices', serverParams.value)
      .then(response => {
        const { total, items } = response.data;
        totalRecords.value = total;
        rows.value = items;
      })
      .catch(error => {
        toastification.showToastError(error);
      }).finally(() => isLoading.value = false);
  };


  const fetchData = () => {
    fetchInvoices();
  };

  const deleteInvoices = invoices => {
    store
      .dispatch('invoice/deleteInvoices', {
        ids: invoices.map(_obj => _obj.id),
      })
      .then(() => {
        fetchData();
        toastification.showToastDeleteSuccess();
      })
      .catch(error => {
        toastification.showToastError(error);
      });
  };

  const updateInvoice = id => {
    isLoading.value = true
    let ids = null
    if (!id) {
      ids = selectedRows.value.map(obj => obj.note)
    } else {
      ids = id
    }
    store
      .dispatch('invoice/updatePOSInvoice', ids)
      .then(response => {
        fetchData()
        toastification.showToastSuccess('Cập nhật hóa đơn thành công')
      })
      .catch(error => {
        toastification.showToastError(error);
      }).finally(() => isLoading.value = false);
  }

  //   Methods
  const updateParams = newProps => {
    serverParams.value = { ...serverParams.value, ...newProps };
    fetchData();
  };

  const issueInvoice = () => {
    console.log(selectedRows.value);
    isLoading.value = true
    try {
      for (const invoice of selectedRows.value) {
        store
          .dispatch('invoice/issueViettelInvoice', invoice.id)
          .then(() => {
            toastification.showToastSuccess('Xuất hóa đơn thành công')
          })
          .catch(error => {
            toastification.showToastErrorWithMessage(error?.message || 'Xuất hóa đơn thất bại')
          });
      }

      fetchData()
      isLoading.value = false
    } catch (error) {
      toastification.showToastErrorWithMessage(error?.message || 'Xuất hóa đơn thất bại')
    }
  }

  const onPageChange = params => {
    updateParams({ page: params.currentPage });
  };

  const onPerPageChange = params => {
    updateParams({ perPage: params.currentPerPage });
  };

  const onSortChange = params => {
    updateParams({
      sort: {
        type: params[0].type,
        field: params[0].field,
      },
    });
  };

  const onColumnFilter = params => {
    updateParams(params);
  };

  const selectionChanged = params => {
    selectedRows.value = params.selectedRows;
    isExportable.value = selectedRows.value.every(obj => obj.oldShuttles === obj.total && obj.numberSessons === 0)
  };

  const onEditItem = val => {
    item.value = val;
  };

  const setPaymentHidden = invoices => {
    const contractIds = invoices.map(obj => obj.contractId);

    const distinct = new Set(contractIds).size;
    if (distinct === 1) {
      // kiem tra xem tat ca da duoc duyet hay chua
      const countApprove = invoices.filter(obj => obj.approve).length;
      const countRemain = invoices.filter(obj => obj.remain !== 0).length;
      if (countApprove === invoices.length && countRemain === invoices.length) {
        return false;
      }
    }
    return true;
  };

  const setDeleteEnable = invoices => {
    // Chi khi tat ca hoa don chua duyet va chua thanh toan moi xoa duoc, con lai la khong hien thi nut xoa
    if (invoices.length === 0) {
      return false;
    }
    return true;
  };

  const syncPOS = () => {
    isLoading.value = true
    const [d1, d2] = selectedDate.value.split(' đến ').map(s => {
      const [day, month, year] = s.split('-').map(Number);
      return new Date(year, month - 1, day);
    });
    const start = Math.floor(d1.getTime() / 1000)
    let end
    if (d2) {
      end = Math.floor((d2.getTime() + 86399999) / 1000)
    } else {
      end = Math.floor((d1.getTime() + 86399999) / 1000)
    }
    store.dispatch('invoice/syncPOS', {
      start, end
    })
      .then(() => {
        fetchData()
        console.log('successed');
        toastification.showToastSuccess('Đồng bộ dữ liệu từ Pancake POS thành công')
      }).catch((e) => {
        console.log('error', e);

        toastification.showToastErrorWithMessage('Đồng bộ dữ liệu lỗi')
      }).finally(() => isLoading.value = false)
  }

  const setApproveHidden = invoices => {
    // Tat ca hoa don dang o trang thai chua duyet thi se hien thi nut approve

    const numOfApprove = invoices.filter(obj => obj.approve === false).length; //se tra ve > 0
    return !(invoices.length > 0 && numOfApprove === invoices.length);
  };

  const setDeclineHidden = invoices => {
    // Hiển thị khi tất cả hóa đơn ở trạng thái đã duyệt
    const numOfDecline = invoices.filter(obj => obj.approve === true).length;
    return !(invoices.length > 0 && numOfDecline === invoices.length);
  };

  const setDeclineDisabled = invoices => {
    // Tat ca hoa don dang o trang thai chua thanh toan thi se enable nut huy

    const numOfApprove = invoices.filter(obj => obj.paid === 0).length;
    return !(invoices.length > 0 && numOfApprove === invoices.length);
    //Check neu co hoa don dang duoc chon hoac so luong hoa don > 0 thi se enable
  };


  const setViettelPreview = state => {
    viettel.value = state
  }

  const approveInvoice = (invoices, approve) => {
    if (invoices && invoices.length > 0) {
      store.dispatch('invoice/approveInvoices', { approve, ids: invoices.map(_obj => _obj.id) }).then(() => {
        fetchInvoices();
      }).catch(error => {
        toastification.showToastError(error);
      });
    }
  };

  //   Watch

  watch(school, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.schoolId = val.id;
    } else {
      delete filter.schoolId;
    }
    updateParams({ filter });
  });
  watch(classObject, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.classId = val.id;
    } else {
      delete filter.classId;
    }
    updateParams({ filter });
  });
  watch(student, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.studentId = val.id;
    } else {
      delete filter.studentId;
    }
    updateParams({ filter });
  });

  watch(status, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.status = val.value;
    } else {
      delete filter.status;
    }
    updateParams({ filter });
  });
  watch(searchTerm, val => {
    updateParams({ searchTerm: val });
  });

  watch(issueStatus, val => {
    const { filter } = serverParams.value;
    if (val) {
      filter.isExportVatInvoice = val.id
    } else {
      delete filter.isExportVatInvoice;
    }
    updateParams({ filter })
  })

  watch(date, val => {
    const filteredDate = moment(val, 'DD-MM-YYYY HH:mm')
    const { filter } = serverParams.value
    if (filteredDate) {
      filter.dueDate = filteredDate
    } else {
      delete filter.dueDate
    }
    updateParams({ filter })
  })
  watch(isEqual, val => {
    const { filter } = serverParams.value
    if (val) {
      filter.isEqual = val.id
    } else {
      delete filter.isEqual
    }
    updateParams({ filter })
  })
  watch(isDiscount, val => {
    const { filter } = serverParams.value
    if (val) {
      filter.isDiscount = val.id
    } else {
      delete filter.isDiscount
    }
    updateParams({ filter })
  })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveInvoiceApproveStatusVariantAndIcon = approve => {
    if (approve) return { variant: 'success', title: 'Đã duyệt' };
    return { variant: 'danger', title: 'Chưa duyệt' };
  };

  const getRemainDaysVariant = remainDays => {
    if (remainDays > 30) {
      return { variant: "light-primary", text: `Còn ${Math.abs(remainDays)} ngày` };
    }
    if (remainDays > 0) {
      return { variant: "light-warning", text: `Còn ${Math.abs(remainDays)} ngày` };
    }
    if (remainDays === 0) {
      return { variant: "light-warning", text: `Quá hạn hôm nay` };
    }
    return { variant: "light-danger", text: `Quá hạn ${Math.abs(remainDays)} ngày` };
  };

  const resolveColWidthIfDisableBed = isBed => {
    if (isEnableBed()) {
      return 3;
    }
    if (isBed) {
      return 0;
    }
    return 4;
  };

  return {
    item,
    paymentItem,
    columns,
    rows,
    school,
    classObject,
    issueStatus,
    student,
    status,
    type,
    selectedRows,
    selectedDate,
    searchTerm,
    isLoading,
    totalRecords,
    serverParams,
    isPOSAccount,
    viettel,
    date,
    isEqual,
    isDiscount,
    isExportable,
    setPaymentHidden,
    approveInvoice,
    fetchData,
    deleteInvoices,
    onEditItem,
    resetItem,
    updateParams,
    onPageChange,
    onPerPageChange,
    onSortChange,
    onColumnFilter,
    selectionChanged,
    resolveInvoiceApproveStatusVariantAndIcon,
    getRemainDaysVariant,
    setApproveHidden,
    setDeclineHidden,
    setDeclineDisabled,
    setDeleteEnable,
    resolveColWidthIfDisableBed,
    syncPOS,
    setViettelPreview,
    t,
    updateInvoice,
    issueInvoice
  };
}
